import { forwardRef } from 'react'

import { SystemIconTemplate } from '../../template/system-icon-template'
import { IconProps } from '../../types/types'

export const ArrowDownSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	return (
		<SystemIconTemplate ref={ref} {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.22038 9.21413C4.93538 9.47158 4.93574 9.91906 5.22115 10.176L11.3309 15.6775C11.7112 16.02 12.2888 16.02 12.6691 15.6775L18.7156 10.233C19.0349 9.94553 19.0353 9.44505 18.7165 9.15711C18.4407 8.90798 18.0211 8.90798 17.7453 9.15711L12.3352 14.0444C12.1448 14.2163 11.8552 14.2163 11.6648 14.0444L6.31778 9.21413C6.00614 8.93261 5.53201 8.93261 5.22038 9.21413Z"
				fill="currentColor"
			/>
		</SystemIconTemplate>
	)
})
